import React from "react";
import { Redirect } from "react-router";

function Form({ lang }) {
	return <Redirect to="/" />;
}

export default Form;
